// extracted by mini-css-extract-plugin
export default {"component":"Header_component__Y6Z1i","logo":"Header_logo__shVBB","actions":"Header_actions__3ReuK","import":"Header_import__s36eR"};